import { Customer } from './../../models/customer';
import { DataService } from 'src/app/services/data.service';
import { ShareClientId } from 'src/app/services/data/companies.service';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogFormService } from 'src/app/services/dialog-form.service';
import { DialogService } from 'src/app/services/dialog.service';
import { RestService } from 'src/app/services/rest.service';
import { MatStepper } from '@angular/material/stepper';
import {
  OptionFormDto,
  OptionFormDtoUpperCase,
} from 'src/app/models/dialog-dto/option-form.dto';
import { CompanyItemDto } from 'src/app/models/dialog-dto/company-list-item.dto';
import { CustomerItemDto } from 'src/app/models/dialog-dto/customer-list-item.dto';
import { LicenceFormDto } from 'src/app/models/dialog-dto/licence-form.dto';
import { LicenceDto } from 'src/app/models/licenceDto';
import { LicenceOptionsService } from 'src/app/modules/shared/services/licence-options.service';
import { Client } from 'src/app/models/client';
import { TranslateService } from '@ngx-translate/core';

interface AddLicenceDialogData {
  licenceData: LicenceDto;
  licenceOptionData: OptionFormDtoUpperCase[];
}

@Component({
  selector: 'app-dialog-add-licence',
  templateUrl: './dialog-add-licence.component.html',
  styleUrls: ['./dialog-add-licence.component.scss'],
})
export class DialogAddLicenceComponent implements OnInit {
  guid: string = '';

  clientSelectForm: FormGroup;
  customerSelectForm: FormGroup;
  licenceForm: FormGroup;
  optionsForm: FormGroup;

  initialCustomer: CustomerItemDto | undefined;
  initialCustomerId: number | undefined;
  initialClient: Client | undefined;
  initialClientId: number | undefined;
  initialLicence: LicenceDto | undefined;
  initialLicenceOptions: OptionFormDtoUpperCase[] | undefined;

  // SMA related properties
  savedLicenceGuid: string = '';
  savedLicenceId: number = 0;
  smaData: any[] = [];

  @ViewChild(MatStepper) stepper!: MatStepper;

  constructor(
    public dialogService: DialogService,
    public dataService: DataService,
    private dialogFormService: DialogFormService,
    public dialogRef: MatDialogRef<DialogAddLicenceComponent>,
    protected shareClientId: ShareClientId,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private restService: RestService,
    @Inject(MAT_DIALOG_DATA) public data: AddLicenceDialogData
  ) {
    translate.currentLoader
    this.clientSelectForm = this.dialogFormService.newCompanySelectForm();
    this.customerSelectForm = this.dialogFormService.newCustomerSelectForm();
    this.licenceForm = this.dialogFormService.newLicenceForm();
    this.optionsForm = this.dialogFormService.newOptionsForm();

    // Clear tmpSmaList to ensure no old data from previous licences
    this.shareClientId.tmpSmaList = [];
    console.log('Dialog constructor: tmpSmaList cleared for new/edit dialogue');
  }

  ngOnInit(): void {
    if (this.data != null) {
      this.dialogService
        .getSelectedCustomer(this.data.licenceData.customer_id)
        .subscribe((customer) => {
          let initialObjects: OptionFormDtoUpperCase[] = this.data
            .licenceOptionData as OptionFormDtoUpperCase[];

          let uniqueObjects = initialObjects.filter(
            (item, index, self) =>
              index ===
              self.findIndex(
                (t) =>
                  t.OptionTypeID === item.OptionTypeID &&
                  t.OptionVersionID === item.OptionVersionID &&
                  t.Value === item.Value &&
                  t.StartDate === item.StartDate &&
                  t.EndDate === item.EndDate
              )
          );


          this.dialogService.getSelectedClient(customer.client.id).subscribe((client) => {
            this.clientSelectForm.get("id")?.setValue(client.company.id)
            this.shareClientId.currentClientObj = client
          })

          this.customerSelectForm.get("id")?.setValue(customer.company.id)

          this.guid = this.data.licenceData.guid;
          this.initialCustomer = customer;
          this.shareClientId.currentCustomerObj = customer;
          this.initialClient = customer.client;
          this.initialLicence = this.data.licenceData;
          this.initialCustomerId = customer.company.id;
          this.initialClientId = customer.client.id;
          this.initialLicenceOptions = uniqueObjects;
          this.shareClientId.tmpDataList = uniqueObjects;
        });
    }
  }

  save() {
    this.dialogFormService
      .saveAddLicenceForm(
        this.shareClientId.currentClientObj,
        this.shareClientId.currentCustomerObj,
        this.shareClientId.currentLicence,
        this.shareClientId.tmpDataList,
        this.guid
      )
      .subscribe((result) => {
        if (result.success) {
          this.dialogRef.close(result.success);
        }
      });
  }

  saveAndContinue() {
    console.log('saveAndContinue called');
    console.log('Current data:', {
      client: this.shareClientId.currentClientObj,
      customer: this.shareClientId.currentCustomerObj,
      licence: this.shareClientId.currentLicence,
      options: this.shareClientId.tmpDataList,
      guid: this.guid,
      sma: this.shareClientId.tmpSmaList,
    });

    this.dialogFormService
      .saveAddLicenceForm(
        this.shareClientId.currentClientObj,
        this.shareClientId.currentCustomerObj,
        this.shareClientId.currentLicence,
        this.shareClientId.tmpDataList,
        this.guid
      )
      .subscribe({
        next: (result) => {
          console.log('Save result:', result);
          if (result.success) {
            if (result.data) {
              this.savedLicenceGuid = result.data.guid || this.guid;
              this.savedLicenceId = result.data.id || 0;
            } else {
              // If no data returned, use the guid we already have
              this.savedLicenceGuid = this.guid;
            }
            // Sync guid so save() updates the already-created licence
            if (!this.guid && this.savedLicenceGuid) {
              this.guid = this.savedLicenceGuid;
            }

            // Load SMA data from backend using the licence GUID
            console.log('Loading SMA data for licence GUID:', this.savedLicenceGuid);
            if (this.savedLicenceGuid) {
              this.restService.get<any>(`/licences/period?licenceId=${this.savedLicenceGuid}`).subscribe({
                next: (smaResponse) => {
                  console.log('SMA data loaded (raw):', smaResponse);
                  // Backend returns array directly, not wrapped in success/data
                  let rawData: any[] = [];
                  if (Array.isArray(smaResponse)) {
                    rawData = smaResponse;
                  } else if (smaResponse.success && smaResponse.data) {
                    rawData = Array.isArray(smaResponse.data) ? smaResponse.data : [smaResponse.data];
                  }

                  // Transform backend format to frontend format
                  this.smaData = rawData.map((item: any) => ({
                    id: item.ID || item.id,
                    guid: item.GUID || item.guid,
                    licence_id: item.LicenceID || item.licence_id,
                    document_number: item.DocumentNumber || item.document_number || '',
                    product_id: item.ProductID || item.product_id || '',
                    start_date: item.StartDate || item.start_date,
                    end_date: item.EndDate || item.end_date,
                    sma_booked: item.SMABooked || item.sma_booked || false,
                    created_at: item.CreatedAt || item.created_at,
                    updated_at: item.UpdatedAt || item.updated_at,
                    project_number: item.ProjectNumber || item.project_number || '',
                    company_name: item.CompanyName || item.company_name || '',
                    project_name: item.ProjectName || item.project_name || '',
                    customer_order_number: item.CustomerOrderNumber || item.customer_order_number || ''
                  }));

                  this.shareClientId.tmpSmaList = this.smaData;
                  console.log('Moving to next step. Licence GUID:', this.savedLicenceGuid, 'ID:', this.savedLicenceId);
                  console.log('SMA Data to display (transformed):', this.smaData);
                  console.log('tmpSmaList:', this.shareClientId.tmpSmaList);
                  this.stepper.next();
                },
                error: (error) => {
                  console.error('Error loading SMA data:', error);
                  // Continue to next step even if loading SMA data fails
                  this.smaData = [];
                  this.shareClientId.tmpSmaList = [];
                  this.stepper.next();
                }
              });
            } else {
              // No licence GUID, continue with empty SMA data
              this.smaData = [];
              this.shareClientId.tmpSmaList = [];
              console.log('Moving to next step. Licence GUID:', this.savedLicenceGuid, 'ID:', this.savedLicenceId);
              this.stepper.next();
            }
          } else {
            console.error('Save was not successful:', result.message);
          }
        },
        error: (error) => {
          console.error('Error saving licence:', error);
        }
      });
  }

  continuePastSma() {
    this.stepper.next();
  }

  saveLicenceWithSma() {
    console.log('=== saveLicenceWithSma called ===');
    console.log('THIS licence GUID:', this.savedLicenceGuid);
    console.log('tmpSmaList length:', this.shareClientId.tmpSmaList?.length || 0);

    // Check if this method is being called multiple times
    if ((this as any)._savingInProgress) {
      console.warn('saveLicenceWithSma already in progress - ignoring duplicate call');
      return;
    }
    (this as any)._savingInProgress = true;

    // Save all SMA entries from tmpSmaList for THIS licence
    if (this.shareClientId.tmpSmaList && this.shareClientId.tmpSmaList.length > 0) {
      const savePromises = this.shareClientId.tmpSmaList.map((smaItem: any) => {
        // Format dates properly
        let startDate = smaItem.StartDate || smaItem.start_date;
        let endDate = smaItem.EndDate || smaItem.end_date;

        // Ensure dates are in ISO format with time
        if (startDate && !startDate.includes('T')) {
          startDate = startDate + 'T00:00:00Z';
        }
        if (endDate && !endDate.includes('T')) {
          endDate = endDate + 'T00:00:00Z';
        }

        const smaDto = {
          LicenceID: this.savedLicenceGuid, // Use THIS licence's GUID
          StartDate: startDate,
          EndDate: endDate
        };

        console.log('Saving SMA for licence:', this.savedLicenceGuid, 'Data:', smaDto);

        // Use PUT if SMA has GUID (editing), POST if new
        if (smaItem.guid) {
          return this.restService.put<any>(`/licences/period/${smaItem.guid}`, smaDto).toPromise();
        } else {
          return this.restService.post<any>('/licences/period', smaDto).toPromise();
        }
      });

      Promise.all(savePromises)
        .then((results) => {
          console.log('All SMA entries saved successfully:', results.length);
          (this as any)._savingInProgress = false;
          this.dialogRef.close(true);
        })
        .catch((error) => {
          console.error('Error saving SMA entries:', error);
          (this as any)._savingInProgress = false;
          this.dialogRef.close(true);
        });
    } else {
      console.log('No SMA entries to save');
      (this as any)._savingInProgress = false;
      this.dialogRef.close(true);
    }
  }

  finish() {
    // Close dialog without saving SMA data
    this.dialogRef.close(true);
  }

  get currentStepIndex(): number {
    return this.stepper ? this.stepper.selectedIndex : -1;
  }

  get customerRequest() {
    return this.dialogService.getCustomerList(
      this.clientSelectForm.get('id')?.value
    );
  }

  onStepChange(event: number) {
    this.cdr.detectChanges();
  }

  resetData() {
    console.log('Data Reset');

    this.shareClientId.currentClientObj = {} as CompanyItemDto;
    this.shareClientId.currentCustomerObj = {} as CustomerItemDto;
    this.shareClientId.currentLicence = {} as LicenceFormDto;
    this.shareClientId.tmpDataList = [];
    this.shareClientId.tmpDataOptions = {} as OptionFormDto;

    this.shareClientId.resetClient();
    this.shareClientId.resetTmpData();
  }
}
